// =============================================================================
// returnTo — "take me back where I came from" (27 Sep 2026)
// =============================================================================
// James, watching the crew flow: "the Site map as the crew sees it navs to
// site maps in HSE, wrong ... same as JMP — the back nav takes them to the
// HSE portal not back to the site folder. Nav needs to be cleaner."
//
// Any screen the Site folder opens (start card, permit, incident form, JMP,
// SWMS) is opened with ?return=/projects/<id>. The screen's back / cancel /
// done buttons go THERE instead of the HSE register, and when it navigates
// onward (new JMP → the JMP it made) the marker rides along. No marker →
// the screen behaves exactly as before.
// =============================================================================

import { useSearchParams } from "react-router-dom";

export function useReturnTo(): string | null {
  const [sp] = useSearchParams();
  const r = sp.get("return");
  // only ever an in-app path — never a full URL someone typed into a link
  return r && r.startsWith("/") && !r.startsWith("//") ? r : null;
}

export function withReturn(path: string, returnTo: string | null | undefined): string {
  if (!returnTo) return path;
  return `${path}${path.includes("?") ? "&" : "?"}return=${encodeURIComponent(returnTo)}`;
}
